export enum MatatuSaccoEnum {
  luminous_matatu_sacco = 'luminous_matatu_sacco-49e9-b9ac-f3c9e3ff52a1',
  embassava_matatu_sacco = 'embassava_matatu_sacco-4dfa-8182-538b5aa204ee',
  astrabel_matatu_sacco = 'astrabel_matatu_sacco-4520-9c82-e1c38f0a8e68',
}
